"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Color = {
  white: 'co--white',
  black: 'co--black',
  gray: {
    100: 'co--gray-100',
    200: 'co--gray-200',
    300: 'co--gray-300',
    400: 'co--gray-400',
    500: 'co--gray-500',
    600: 'co--gray-600',
    700: 'co--gray-700',
    800: 'co--gray-800',
    900: 'co--gray-900'
  },
  midnight: {
    100: 'co--midnight-100',
    200: 'co--midnight-200',
    300: 'co--midnight-300',
    400: 'co--midnight-400',
    500: 'co--midnight-500',
    600: 'co--midnight-600',
    700: 'co--midnight-700',
    800: 'co--midnight-800',
    900: 'co--midnight-900'
  },
  primary: {
    200: 'co--primary-200',
    300: 'co--primary-300',
    400: 'co--primary-400',
    500: 'co--primary-500',
    600: 'co--primary-600',
    700: 'co--primary-700',
    800: 'co--primary-800',
    900: 'co--primary-900'
  },
  secondary: {
    200: 'co--secondary-200',
    300: 'co--secondary-300',
    400: 'co--secondary-400',
    500: 'co--secondary-500',
    600: 'co--secondary-600',
    700: 'co--secondary-700',
    800: 'co--secondary-800',
    900: 'co--secondary-900'
  },
  tertiary: {
    200: 'co--tertiary-200',
    300: 'co--tertiary-300',
    400: 'co--tertiary-400',
    500: 'co--tertiary-500',
    600: 'co--tertiary-600',
    700: 'co--tertiary-700',
    800: 'co--tertiary-800',
    900: 'co--tertiary-900'
  },
  green: {
    200: 'co--green-200',
    300: 'co--green-300',
    400: 'co--green-400',
    500: 'co--green-500',
    600: 'co--green-600',
    700: 'co--green-700',
    800: 'co--green-800',
    900: 'co--green-900'
  },
  yellow: {
    200: 'co--yellow-200',
    300: 'co--yellow-300',
    400: 'co--yellow-400',
    500: 'co--yellow-500',
    600: 'co--yellow-600',
    700: 'co--yellow-700',
    800: 'co--yellow-800',
    900: 'co--yellow-900'
  },
  red: {
    200: 'co--red-200',
    300: 'co--red-300',
    400: 'co--red-400',
    500: 'co--red-500',
    600: 'co--red-600',
    700: 'co--red-700',
    800: 'co--red-800',
    900: 'co--red-900'
  },
  orange: {
    200: 'co--orange-200',
    300: 'co--orange-300',
    400: 'co--orange-400',
    500: 'co--orange-500',
    600: 'co--orange-600',
    700: 'co--orange-700',
    800: 'co--orange-800',
    900: 'co--orange-900'
  },
  blue: {
    200: 'co--blue-200',
    300: 'co--blue-300',
    400: 'co--blue-400',
    500: 'co--blue-500',
    600: 'co--blue-600',
    700: 'co--blue-700',
    800: 'co--blue-800',
    900: 'co--blue-900'
  },
  background: {
    white: 'co--bg-white',
    black: 'co--bg-black',
    gray: {
      100: 'co--bg-gray-100',
      200: 'co--bg-gray-200',
      300: 'co--bg-gray-300',
      400: 'co--bg-gray-400',
      500: 'co--bg-gray-500',
      600: 'co--bg-gray-600',
      700: 'co--bg-gray-700',
      800: 'co--bg-gray-800',
      900: 'co--bg-gray-900'
    },
    midnight: {
      100: 'co--bg-midnight-100',
      200: 'co--bg-midnight-200',
      300: 'co--bg-midnight-300',
      400: 'co--bg-midnight-400',
      500: 'co--bg-midnight-500',
      600: 'co--bg-midnight-600',
      700: 'co--bg-midnight-700',
      800: 'co--bg-midnight-800',
      900: 'co--bg-midnight-900'
    },
    primary: {
      200: 'co--bg-primary-200',
      300: 'co--bg-primary-300',
      400: 'co--bg-primary-400',
      500: 'co--bg-primary-500',
      600: 'co--bg-primary-600',
      700: 'co--bg-primary-700',
      800: 'co--bg-primary-800',
      900: 'co--bg-primary-900'
    },
    secondary: {
      200: 'co--bg-secondary-200',
      300: 'co--bg-secondary-300',
      400: 'co--bg-secondary-400',
      500: 'co--bg-secondary-500',
      600: 'co--bg-secondary-600',
      700: 'co--bg-secondary-700',
      800: 'co--bg-secondary-800',
      900: 'co--bg-secondary-900'
    },
    tertiary: {
      200: 'co--bg-tertiary-200',
      300: 'co--bg-tertiary-300',
      400: 'co--bg-tertiary-400',
      500: 'co--bg-tertiary-500',
      600: 'co--bg-tertiary-600',
      700: 'co--bg-tertiary-700',
      800: 'co--bg-tertiary-800',
      900: 'co--bg-tertiary-900'
    },
    green: {
      200: 'co--bg-green-200',
      300: 'co--bg-green-300',
      400: 'co--bg-green-400',
      500: 'co--bg-green-500',
      600: 'co--bg-green-600',
      700: 'co--bg-green-700',
      800: 'co--bg-green-800',
      900: 'co--bg-green-900'
    },
    yellow: {
      200: 'co--bg-yellow-200',
      300: 'co--bg-yellow-300',
      400: 'co--bg-yellow-400',
      500: 'co--bg-yellow-500',
      600: 'co--bg-yellow-600',
      700: 'co--bg-yellow-700',
      800: 'co--bg-yellow-800',
      900: 'co--bg-yellow-900'
    },
    red: {
      200: 'co--bg-red-200',
      300: 'co--bg-red-300',
      400: 'co--bg-red-400',
      500: 'co--bg-red-500',
      600: 'co--bg-red-600',
      700: 'co--bg-red-700',
      800: 'co--bg-red-800',
      900: 'co--bg-red-900'
    },
    orange: {
      200: 'co--bg-orange-200',
      300: 'co--bg-orange-300',
      400: 'co--bg-orange-400',
      500: 'co--bg-orange-500',
      600: 'co--bg-orange-600',
      700: 'co--bg-orange-700',
      800: 'co--bg-orange-800',
      900: 'co--bg-orange-900'
    },
    blue: {
      200: 'co--bg-blue-200',
      300: 'co--bg-blue-300',
      400: 'co--bg-blue-400',
      500: 'co--bg-blue-500',
      600: 'co--bg-blue-600',
      700: 'co--bg-blue-700',
      800: 'co--bg-blue-800',
      900: 'co--bg-blue-900'
    }
  }
};
var _default = Color;
exports.default = _default;